import { useState } from "react";
import PageBanner from "../components/PageBanner";
import { SITE, WHATSAPP_LINK } from "../data/siteConfig";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });
  const [sent, setSent] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(
      `Enquiry from ${form.name || "Website"} - POSH Compliance`,
    );
    const body = encodeURIComponent(
      `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email}\n\nMessage:\n${form.message}`,
    );
    window.location.href = `mailto:${SITE.email}?subject=${subject}&body=${body}`;
    setSent(true);
    setTimeout(() => setSent(false), 5000);
  };

  return (
    <div data-testid="contact-page">
      <PageBanner
        crumb="Contact"
        title="Contact Us"
        subtitle="Get in touch with us for POSH training, compliance support, or legal consultation. We respond within 24 hours."
         className="rs-contact-banner"
      />

      {/* Contact Cards */}
      <section className="section" data-testid="contact-info-section">
        <div className="container">
          <div className="row g-4 mb-5">
            <div className="col-lg-4 col-md-6" data-aos="fade-up">
              <div className="rs-contact-card">
                <div className="rs-contact-icon primary">
                  <i className="bi bi-telephone-fill"></i>
                </div>
                <h5>Call Us</h5>
                <a href={SITE.phoneHref} data-testid="contact-phone">{SITE.phone}</a>
                <small>Mon - Sat · 10:00 AM - 7:00 PM IST</small>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="rs-contact-card">
                <div className="rs-contact-icon accent">
                  <i className="bi bi-whatsapp"></i>
                </div>
                <h5>WhatsApp</h5>
                <a
                  href={WHATSAPP_LINK}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="contact-whatsapp"
                >
                  Chat with us on WhatsApp
                </a>
                <small>Usually replies within an hour</small>
              </div>
            </div>
            <div className="col-lg-4 col-md-12" data-aos="fade-up" data-aos-delay="200">
              <div className="rs-contact-card">
                <div className="rs-contact-icon dark">
                  <i className="bi bi-envelope-fill"></i>
                </div>
                <h5>Email Us</h5>
                <a href={SITE.emailHref} data-testid="contact-email">{SITE.email}</a>
                <small>Response within 24 hours</small>
              </div>
            </div>
          </div>

          {/* Form + Side Info */}
          <div className="row g-5 align-items-stretch">
            <div className="col-lg-7" data-aos="fade-right">
              <form
                className="rs-form"
                onSubmit={handleSubmit}
                data-testid="contact-form"
              >
                <div className="mb-4">
                  <span className="eyebrow">Send Message</span>
                  <h3 style={{ fontSize: "1.7rem", marginTop: "6px", marginBottom: "8px" }}>
                    We'd love to hear from you
                  </h3>
                  <p style={{ margin: 0 }}>
                    Tell us about your compliance goals, training needs or
                    governance challenges.
                  </p>
                </div>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      placeholder="Ramesh Kumar"
                      className="form-control"
                      value={form.name}
                      onChange={handleChange}
                      data-testid="form-name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="phone">Phone *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      required
                      placeholder="+91 90000 00000"
                      className="form-control"
                      value={form.phone}
                      onChange={handleChange}
                      data-testid="form-phone"
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      placeholder="you@company.com"
                      className="form-control"
                      value={form.email}
                      onChange={handleChange}
                      data-testid="form-email"
                    />
                  </div>
                  <div className="col-12">
                    <label htmlFor="message">Message *</label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      placeholder="Tell us about your organization and compliance needs..."
                      className="form-control"
                      value={form.message}
                      onChange={handleChange}
                      data-testid="form-message"
                    ></textarea>
                  </div>
                  <div className="col-12 d-flex flex-wrap gap-3 align-items-center">
                    <button
                      type="submit"
                      className="btn btn-rs-primary"
                      data-testid="form-submit"
                    >
                      Send Message <i className="bi bi-send-fill"></i>
                    </button>
                    <a
                      href={WHATSAPP_LINK}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-rs-outline"
                    >
                      <i className="bi bi-whatsapp"></i> WhatsApp Instead
                    </a>
                    {sent && (
                      <span
                        className="d-inline-flex align-items-center gap-2"
                        style={{ color: "var(--rs-accent)", fontWeight: 600 }}
                        data-testid="form-success"
                      >
                        <i className="bi bi-check-circle-fill"></i>
                        Opening your email app...
                      </span>
                    )}
                  </div>
                </div>
              </form>
            </div>

            <div className="col-lg-5" data-aos="fade-left">
              <div
                style={{
                  background:
                    "linear-gradient(135deg, var(--rs-dark), var(--rs-primary))",
                  borderRadius: "22px",
                  padding: "40px 36px",
                  color: "#fff",
                  height: "100%",
                  boxShadow: "var(--rs-strong-shadow)",
                }}
              >
                <span
                  className="eyebrow"
                  style={{
                    background: "rgba(255,255,255,0.14)",
                    color: "#fff",
                  }}
                >
                  Quick Connect
                </span>
                <h3 style={{ color: "#fff", marginTop: "10px" }}>
                  Talk to a certified POSH trainer today
                </h3>
                <p style={{ color: "rgba(255,255,255,0.85)" }}>
                  For quick queries, reach us directly — we're here to help.
                </p>

                <div className="mt-4">
                  {[
                    { icon: "bi-telephone-fill", label: "Phone", value: SITE.phone, href: SITE.phoneHref },
                    { icon: "bi-envelope-fill", label: "Email", value: SITE.email, href: SITE.emailHref },
                    { icon: "bi-whatsapp", label: "WhatsApp", value: "wa.me/919027795197", href: WHATSAPP_LINK, ext: true },
                  ].map((item, i) => (
                    <a
                      key={i}
                      href={item.href}
                      target={item.ext ? "_blank" : undefined}
                      rel="noreferrer"
                      className="d-flex align-items-center gap-3 py-3"
                      style={{
                        borderBottom: "1px solid rgba(255,255,255,0.15)",
                        color: "#fff",
                      }}
                    >
                      <div
                        style={{
                          width: "44px",
                          height: "44px",
                          borderRadius: "12px",
                          background: "rgba(255,255,255,0.14)",
                          display: "grid",
                          placeItems: "center",
                          fontSize: "1.1rem",
                        }}
                      >
                        <i className={`bi ${item.icon}`}></i>
                      </div>
                      <div>
                        <small
                          style={{
                            color: "rgba(255,255,255,0.65)",
                            display: "block",
                            fontSize: "0.8rem",
                            letterSpacing: "0.05em",
                            textTransform: "uppercase",
                          }}
                        >
                          {item.label}
                        </small>
                        <strong
                          style={{
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "1rem",
                            color: "#fff",
                          }}
                        >
                          {item.value}
                        </strong>
                      </div>
                      <i
                        className="bi bi-arrow-up-right ms-auto"
                        style={{ color: "rgba(255,255,255,0.7)" }}
                      ></i>
                    </a>
                  ))}
                </div>

                <div
                  style={{
                    marginTop: "28px",
                    padding: "18px 20px",
                    background: "rgba(255,255,255,0.08)",
                    borderRadius: "14px",
                    border: "1px solid rgba(255,255,255,0.12)",
                  }}
                >
                  <div className="d-flex gap-2 align-items-center">
                    <i
                      className="bi bi-clock-fill"
                      style={{ color: "#7ed4ff", fontSize: "1.15rem" }}
                    ></i>
                    <strong style={{ fontFamily: "Poppins", color: "#fff" }}>
                      Business Hours
                    </strong>
                  </div>
                  <p
                    style={{
                      margin: "6px 0 0",
                      color: "rgba(255,255,255,0.8)",
                      fontSize: "0.92rem",
                    }}
                  >
                    Mon - Sat: 10:00 AM - 7:00 PM IST
                    <br />
                    Sunday: Closed (WhatsApp available)
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
